import { render, staticRenderFns } from "./RightSideMenu.vue?vue&type=template&id=89896024&"
import script from "./RightSideMenu.vue?vue&type=script&lang=ts&"
export * from "./RightSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RightSideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
